import { P } from '@ahmdigital/ui';
import React from 'react';

import { featuresWithAccidentOverride, StyledSmall } from './shared';

export default {
  intro: {
    description: (
      <>
        <P>
          You can’t plan for an accident, but you can plan for getting hospital cover where we have your back for
          Accidents. And, you won’t have to pay an excess for these Accidents<StyledSmall>#</StyledSmall> - double the
          win!
        </P>
        {featuresWithAccidentOverride.features}
      </>
    ),
    disclaimer: featuresWithAccidentOverride.disclaimers,
  },
};
